import React, { useState, useEffect } from 'react'
import firebase from '../../../firebase'
import { Link } from 'react-router-dom'
import PurchasesMateriaForm from './PurchasesMateriaForm';

const Item = (props) => {
    const {data} = props
    return (
        <tr>
            <td>{data.code}</td>
            <td>{data.name}</td>
            <td>{data.description}</td>
            <td><Link to={`/compras/materia-prima/${data.id}`}><i className="material-icons">chevron_right</i></Link></td>
        </tr>
    )
}

const PurchasesMateria = () => {

    const [products,setProducts] = useState([])

    useEffect(() => {
        firebase.getCollectionRealTime('materials').onSnapshot(snap => {
            const products = snap.docs.map(doc => doc.data())
            setProducts(products)
        })
    }, [])

    return (
        <div className="configuration-products">
            <PurchasesMateriaForm/>
            <div className="container">
                <table>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Ver</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(products).map(key => <Item key={key} data={products[key]} />)
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default PurchasesMateria